import { Box, Typography, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "./Button";
import { useAppUrl } from "../hooks/useAppUrl";

const BannerContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  backgroundColor: "var(--brand-primary)",
  borderRadius: "32px",
  overflow: "hidden",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column-reverse",
    borderRadius: "24px",
  },
  "&::before": {
    content: '""',
    position: "absolute",
    left: "30px",
    top: "30px",
    bottom: "30px",
    width: "calc(100% - 60px)",
    pointerEvents: "none",
    zIndex: 0,
    backgroundImage: "url('/assets/ellipse-group.webp')",
    backgroundPosition: "left center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

const ContentSection = styled(Box)(({ theme }) => ({
  width: "50%",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  padding: "60px 60px 100px 60px",
  minHeight: "650px",
  justifyContent: "center",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    padding: "40px 20px 48px 20px",
    minHeight: "auto",
    alignItems: "center",
    textAlign: "center",
    width: "100%",
  },
}));

const BannerTitle = styled(Typography)(({ theme }) => ({
  color: "var(--text-white)",
  "& .italic": {
    fontStyle: "italic",
    fontWeight: 400,
  },
  [theme.breakpoints.down("md")]: {
    fontSize: "var(--heading-h2-mobile-font-size)",
    lineHeight: "var(--heading-h2-mobile-line-height)",
  },
}));

const ImageSection = styled(Box)(({ theme }) => ({
  width: "50%",
  height: "650px",
  backgroundColor: "var(--background-tertiary)",
  borderRadius: "32px",
  overflow: "hidden",
  position: "relative",
  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "364px",
    borderRadius: "24px 24px 0 0",
  },
}));

const BannerImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
});


export const BannerSection = () => {
  const { t } = useTranslation();
  const appUrl = useAppUrl();

  return (
    <BannerContainer>
      <ContentSection>
        <BannerTitle variant="h2">
          {t("banner.title")}{" "}
          <span className="italic">{t("banner.titleItalic")}</span>
        </BannerTitle>
        <Box>
          <Button 
            variant="green" 
            size="m"
            onClick={() => window.open(appUrl, '_blank', 'noopener,noreferrer')}
          >
            {t("banner.cta")}
          </Button>
        </Box>
      </ContentSection>
      <ImageSection>
        <BannerImage src="/assets/banner-img.webp" alt={t("images.bannerAlt")} />
      </ImageSection>
    </BannerContainer>
  );
};
